import toast from 'react-hot-toast';
import React from 'react';
import Icon from '@mdi/react';
import {mdiClose} from '@mdi/js';
import {IconButton} from '@material-ui/core';

export default (
  text: string | string[],
  type: 'success' | 'info' | 'error' | 'warn' | 'm-success' | 'm-error'
) => {
  switch (type) {
    case 'm-success':
      toast.success(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <p>
            {text.map(el => {
              return (
                <>
                  <span>{el}</span>
                  <br />
                </>
              );
            })}
          </p>
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <Icon path={mdiClose} size={0.8} color="#fff" />
          </IconButton>
        </div>
      ));
      break;
    case 'm-error':
      toast.error(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <Icon path={mdiClose} size={0.8} color="#fff" />
          </IconButton>
        </div>
      ));
      break;
    case 'success':
      toast.success(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <Icon path={mdiClose} size={0.8} color="#fff" />
          </IconButton>
        </div>
      ));
      break;
    case 'error':
      toast.error(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <Icon path={mdiClose} size={0.8} color="#fff" />
          </IconButton>
        </div>
      ));
      break;
    case 'warn':
      toast(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <Icon path={mdiClose} size={0.8} color="#fff" />
          </IconButton>
        </div>
      ));
      break;
    case 'info':
      toast(t => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {text}
          <IconButton onClick={() => toast.dismiss(t.id)}>
            <Icon path={mdiClose} size={0.8} color="#fff" />
          </IconButton>
        </div>
      ));
      break;
    default:
      toast(text, {
        position: 'top-right',
        duration: 5000,
      });
      break;
  }
};
